export interface Connector {
  id: string;
  label: string;
  icon: string;          // lucide icon name
  description?: string;
  configured: boolean;
  hasSubmenu?: boolean;
}

export const CONNECTORS: Connector[] = [
  { id: 'github',   label: 'GitHub',     icon: 'Github',     configured: false },
  { id: 'files',    label: 'Local files', icon: 'FolderTree', configured: true  },
  { id: 'terminal', label: 'Terminal',   icon: 'Terminal',   configured: false },
  { id: 'browser',  label: 'Browser',    icon: 'Globe',      configured: false },
  { id: 'database', label: 'Database',   icon: 'Database',   configured: false },
  { id: 'docs',     label: 'Docs',       icon: 'BookOpen',   configured: false },
  { id: 'openclaw', label: 'OpenClaw',   icon: 'Cpu',        configured: false },
  { id: 'nexusos',  label: 'NexusOS',    icon: 'CircuitBoard', configured: false },
  { id: 'mcp',      label: 'Custom MCP', icon: 'PlugZap',    configured: false, hasSubmenu: true },
];
